import React from 'react';
import { motion } from 'framer-motion';
export function Header() {
  return <motion.header initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 bg-cream/90 backdrop-blur-md border-b border-gold/20" data-id="element-71">
      <div className="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-72">
        <div className="font-serif font-semibold text-xl text-navy tracking-wide" data-id="element-73">
          Protocolo 72H
        </div>
        <a href="#precio" onClick={e => {
        e.preventDefault();
        const target = document.getElementById('precio');
        if (!target) return;
        const startY = window.scrollY;
        const endY = target.getBoundingClientRect().top + window.scrollY;
        const distance = endY - startY;
        const duration = 3500;
        let startTime: number | null = null;
        const easeInOutQuad = (t: number) => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
        const step = (timestamp: number) => {
          if (startTime === null) startTime = timestamp;
          const elapsed = timestamp - startTime;
          const progress = Math.min(elapsed / duration, 1);
          window.scrollTo(0, startY + distance * easeInOutQuad(progress));
          if (progress < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
      }} className="text-sm font-medium text-navy hover:text-gold transition-colors duration-300 border border-navy/20 hover:border-gold px-5 py-2 rounded-full cursor-pointer" data-id="element-74">
          Comenzar Ahora
        </a>
      </div>
    </motion.header>;
}